var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopometryNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 18,
    width: 29,
    height: 8,
    rx: 4,
    transform: "rotate(180 30 18)",
    fill: "#F9CF48",
    fillOpacity: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 13.4985,
    width: 21,
    height: 8,
    rx: 4,
    transform: "rotate(-40 0 13.4985)",
    fill: "#F9CF48",
    fillOpacity: 0.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 22,
    width: 21,
    height: 8,
    rx: 4,
    fill: "#F9CF48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopometryNew);
export default __webpack_public_path__ + "static/media/shopometry-new.cd772455299ba94926ffc8a736ed4958.svg";
export { ForwardRef as ReactComponent };